import Playground from 'components/Playground';
import Alert from "components/Alert";
import * as React from 'react';
export default {
  Playground,
  Alert,
  React
};